<template>
    <el-table
        stripe
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
    >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="recordDate" :label="$t('integration.record_date')" show-overflow-tooltip>
            <template #default="{ row }">
                <i v-icon="['approvalStatusConvert', row.approve]"></i>
                <span>{{ row.recordDate }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="scopeName" :label="$t('public.table_scope')" show-overflow-tooltip />
        <el-table-column prop="architecture" :label="$t('public.table_arch')" show-overflow-tooltip />
        <el-table-column prop="carrierName" :label="$t('public.table_carrier')" show-overflow-tooltip>
            <template #default="{ row }">
                <i :class="carrierFn(row.carrierTypeId)" :title="carrierTitleFn(row.carrierTypeId)"></i>
                <span>{{ row.carrierName }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('public.status')" show-overflow-tooltip>
            <template #default="{ row }">
                <i :class="statusFn(row.status)"></i>
            </template>
        </el-table-column>
        <el-table-column prop="current" :label="$t('public.amount')" show-overflow-tooltip>
            <template #default="{ row }">
                <span>{{ row.current }}/{{ row.cnt }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="approveName" :label="$t('integration.approver')" show-overflow-tooltip />
        <!-- <el-table-column prop="approveName" :label="$t('integration.approver')" show-overflow-tooltip /> -->
        <el-table-column prop="timePoint" :label="$t('integration.record_point')" show-overflow-tooltip />
        <el-table-column prop="approveTime" :label="$t('integration.approval_time')" show-overflow-tooltip>
            <template #default="{ row }">
                <span>{{ row['approveTime'] ? $timetransition(row['approveTime']) : $t('integration.not_approved') }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="Operate" :label="$t('tableTitle.Operating')" width="140px" fixed="right" align="center">
            <template #default="{ row }">
                <el-button type="text" size="small" icon="el-icon-check" :title="$t('integration.approved')" @click="handle('approveFn', row)" v-if="row.approve === null"></el-button>
                <el-button type="text" size="small" icon="el-icon-close" :title="$t('integration.approval_rejected')" @click="handle('noApproveFn', row)" v-if="row.approve === null"></el-button>
                <el-button type="text" size="small" icon="el-icon-tickets" :title="$t('integration.record_details')" @click="handle('detailFn', row)"></el-button>
                <el-button type="text" size="small" icon="el-icon-delete" :title="$t('integration.delete_record_point')" @click="handle('delRowFn', row)"></el-button>

                <!-- v-has="item.vHas" -->
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { SET_ICON_TITLE_FN } from '@/utils/iconMatch.js';
import { carrierIcon } from '@/utils/icon.js';
export default {
    props: ['tableData', 'loading'],
    data() {
        return {
            tableHeight: 'calc(100% - 60px)'
        };
    },

    methods: {
        handle(method, row) {
            this.$emit(method, row);
        },
        statusFn(status) {
            return status === 1 ? 'el-icon-check' : '';
        },
        carrierFn(carrierId) {
            return SET_ICON_TITLE_FN(carrierId, 'icon', carrierIcon);
        },
        carrierTitleFn(carrierId) {
            return SET_ICON_TITLE_FN(carrierId, 'title', carrierIcon);
        },
        iconFn(approve) {
            return approve === 1 ? 'el-icon-circle-check green' : approve === 0 ? 'el-icon-circle-close red' : 'el-icon-circle-close grey';
        },
        handleSelectionChange(arg) {
            this.$emit('choozeTable', arg);
        }
    }
};
</script>
